import React, { useEffect, useState } from 'react';
import { Dropdown } from 'bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import capitalize from '../../../utils/capitalize';
import AjaxSelect from '../AjaxSelect';
import { logout } from '../../../services/authService';
import { toast } from 'react-toastify';
import { footerLogo, logo } from '../../../../images';
import { useNotifications } from '../../../hooks/useNotifications';
import { toTitleCase } from '../../../common/TotitleCase';
import formatDate from '../../../common/DateFormate';

const Header = ({ isLogo }) => {
  const navigate = useNavigate();
  const email = localStorage.getItem('email');
  const firstName = localStorage.getItem('first_name');
  const lastName = localStorage.getItem('last_name');
  const [accountOptions, setAccountOptions] = useState([]);

  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.querySelectorAll('.dropdown-toggle').forEach(dropdownToggleEl => {
      new Dropdown(dropdownToggleEl);
    });

    // document.body.classList.toggle('dark-theme', theme === 'dark');
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem('theme', theme);

    // Dispatch custom event
    window.dispatchEvent(new Event('themeChanged'));
  }, [theme]);

  const handleLogout = async () => {
    try {
      const apiRes = await logout();
      const theme = localStorage.getItem('theme');
      localStorage.clear();
      if (theme !== null) {
        localStorage.setItem('theme', theme);
      }
      toast.success(apiRes.message || 'Logged out successfully', {
        position: "bottom-right",
      })
      // navigate('/signin');
      window.location.href = '/signin';
    }
    catch (err) {
      console.error('Failed to called logout API : ', err)
    }
  };

  const toggleSidebar = () => {
    document.body.classList.toggle('toggle-sidebar');
  };

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementById("header");
      if (!header) return;

      if (window.scrollY > 0) {
        header.classList.remove("with-shadow");
      } else {
        header.classList.add("with-shadow");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { notifications, setNotifications, markNotificationAsRead, markAllAsRead } = useNotifications();

  const unreadCount = notifications && notifications.filter(n => !n.isRead).length;

  const getTypeConfig = (priority, type) => {
    const map = {
      medium: { icon: "bi-exclamation-triangle-fill", gradient: "linear-gradient(135deg,#f59e0b,#d97706)" },
      low: { icon: "bi-info-circle-fill", gradient: "linear-gradient(135deg,#3b82f6,#2563eb)" },
      high: { icon: "bi-x-circle-fill", gradient: "linear-gradient(135deg,#ef4444,#dc2626)" },
    };
    if (["sales_growth", "hero_product_alert"].includes(type)) {
      return {
        icon: "bi-graph-up-arrow",
        gradient: "linear-gradient(135deg,#22c55e,#16a34a)"
      };
    }
    return map[priority] || map.low;
  };
  const handleClick = (notification) => {
    if (!notification.isRead) {
      markNotificationAsRead(notification.id);
    }

    navigate("/notifications");
    document.body.click();
  };
  const viewAll = () => {
    navigate('/notifications')
  }
  const openNotificationSettings = () => {
    navigate('/notification-settings')
  }
  return (
    <header id="header" className="header fixed-top d-flex align-items-center justify-content-between px-3">
      {/* Hamburger Icon for Mobile */}
      {!isLogo ?
        <div className="d-xl-none d-flex align-items-center">
          <i
            className="bi bi-list fs-2"
            onClick={toggleSidebar}
            style={{ cursor: 'pointer', color: '#000' }}
          ></i>
        </div> :
        <div className='p-1'>
          <img
            style={{ height: '35px' }}
            src={(theme === "dark") ? footerLogo : logo}
            alt="Gapalyze Logo"
            className={(theme === "dark") ? "logo-sidebar-image-dark" : "logo-sidebar-image"}
          />
        </div>
      }

      {/* Right Section (Theme + Profile) */}
      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">
          {accountOptions !== null &&
            <li className="nav-item dropdown pe-2">
              <div style={{ minWidth: "150px" }}>
                <AjaxSelect
                  id="marketplace-select"
                  setAccountOptions={setAccountOptions}
                />
              </div>
            </li>
          }
          <li className="nav-item dropdown pe-3">
            <div className="dropdown">
              {/* 🔔 Bell */}
              <button
                className="btn position-relative bg-light rounded-circle py-0 px-2"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-bell fs-4 theme-icon"></i>
                {unreadCount > 0 && (
                  <span
                    class="position-absolute top-0 start-100 translate-middle rounded-circle bg-danger text-white d-flex justify-content-center align-items-center"
                    style={{ width: "22px", height: "23px", fontSize: "12px" }}
                  >
                    {unreadCount}
                  </span>
                )}
              </button>

              {/* 🔽 Dropdown Panel */}
              <div className="dropdown-menu dropdown-menu-end p-0 rounded-circle" style={{ width: 420 }}>
                <div
                  style={{
                    borderRadius: 16,
                    overflow: "hidden",
                    boxShadow: "0 20px 40px rgba(0,0,0,.15)"
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      background: "linear-gradient(135deg,#667eea,#764ba2)",
                      padding: "0.5rem 1.2rem",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="text-white fw-bold mb-0">
                        <i className="bi bi-bell-fill me-2"></i>
                        Notifications
                      </h6>

                      <div className="d-flex align-items-center gap-2">
                        {/* Settings Icon */}
                        <button
                          className="btn btn-sm text-white"
                          onClick={openNotificationSettings}   // your settings handler
                        >
                          <i className="bi bi-gear"></i>
                        </button>
                        {/* Mark All Button */}
                        {unreadCount > 0 && (
                          <button
                            className="btn btn-sm text-white"
                            onClick={markAllAsRead}
                          >
                            Mark all
                          </button>
                        )}
                      </div>
                    </div>


                    <small className="text-white opacity-75">
                      {unreadCount} Unread
                    </small>
                  </div>

                  {/* Body */}
                  <div style={{ maxHeight: 360, overflowY: "auto", background: "#fff" }}>
                    {notifications.length === 0 && (
                      <div className="p-4 text-center text-muted">
                        No notifications
                      </div>
                    )}

                    {notifications && notifications.slice(0, 5).map((n, index) => {
                      const cfg = getTypeConfig(n.priority, n.type);

                      return (
                        <div
                          key={n.id}
                          onClick={() => { handleClick(n) }}
                          style={{
                            cursor: "pointer",
                            padding: "1rem",
                            borderBottom: index !== notifications.length - 1
                              ? "1px solid #f1f5f9"
                              : "none",
                            background: n.isRead ? "#fff" : "#f9fafb",
                            transition: "all .2s",
                          }}
                        >
                          <div className="d-flex gap-3">
                            <div className='p-3'
                              style={{
                                width: 42,
                                height: 42,
                                borderRadius: 12,
                                background: cfg.gradient,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i className={`${cfg.icon} text-white`}></i>
                            </div>
                            <div className="flex-grow-1">
                              <div className="d-flex justify-content-between align-items-center mt-1" style={{ color: "black", fontWeight: n.isRead ? "" : "700", }}>
                                <div className="kpi-name small" style={{ color: "#1e293b", fontWeight: n.isRead ? "" : "700", }}>
                                  {toTitleCase(n.title)}
                                </div>
                                <div className="small text-muted text-nowrap ms-2 notification-date">
                                  {formatDate(n.created_at)}
                                </div>
                              </div>
                              {/* ✅ Message + Date in same row */}
                              <div className="text-muted small text-truncate" style={{ maxWidth: "75%", fontWeight: n.isRead ? "" : "700", }}>
                                {n.message}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}


                  </div>
                  <div className="d-flex justify-content-center px-1 align-items-center bg-transparent">
                    {notifications.length >= 5 && (
                      <button
                        className="text-dark border-0 bg-transparent p-2 fw-semibold "
                        onClick={viewAll}
                      >
                        View All
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* <ul className="dropdown-menu dropdown-menu-end notification-dropdown">
              <li className="dropdown-header">Notifications</li>
              <li><hr className="dropdown-divider" /></li>

              {notifications.length === 0 && (
                <li className="dropdown-item text-muted">
                  No notifications
                </li>
              )}

              {notifications.map(notification => (
                <li
                  key={notification.id}
                  className={`dropdown-item ${notification.is_read ? "" : "fw-bold"}`}
                  onClick={() => {
                    markAsRead(notification.id);
                    navigate(`/notifications/${notification.id}`);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div>{notification.title}</div>
                  <small className="text-muted">{notification.message}</small>
                </li>
              ))}
            </ul> */}
          </li>

          <li className="nav-item dropdown pe-2" onClick={toggleTheme} style={{ cursor: "pointer" }}>
            {theme === 'dark' ? (
              <i
                className="bi bi-sun theme-icon rounded-circle bg-light d-flex justify-content-center align-items-center"
                style={{
                  fontSize: '1.2rem',
                  width: '40px',
                  height: '40px',
                }}
              ></i>) : (
              <i
                className="bi bi-moon-stars theme-icon bg-light rounded-circle d-flex justify-content-center align-items-center"
                style={{
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                }}
              ></i>)}
          </li>
          {/* Profile Dropdown */}
          <li className="nav-item dropdown pe-3">
            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
              <span className="dropdown-toggle d-flex align-items-center ps-2">
                <i
                  className="bi bi-person bg-light profile-icon rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    fontSize: '1.5rem',
                    width: '40px',
                    height: '40px',
                  }}
                ></i>
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile profile-card">
              <li className="dropdown-header">
                <h6 className='kpi-heading'>
                  {firstName || lastName
                    ? `${capitalize(firstName)} ${capitalize(lastName)}`
                    : email}
                </h6>
              </li>
              <li><hr className="dropdown-divider" /></li>

              <li>
                <Link className="dropdown-item d-flex align-items-center kpi-name" to="/profile">
                  <i className="bi bi-person"></i>
                  <span>My Profile</span>
                </Link>
              </li>
              <li><hr className="dropdown-divider" /></li>

              <li>
                <a
                  className="dropdown-item d-flex align-items-center kpi-name"
                  href="logout"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
